import { render, staticRenderFns } from "./AvbKeiExpertiseDeleteDialog.vue?vue&type=template&id=5a3c38ac"
import script from "./AvbKeiExpertiseDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AvbKeiExpertiseDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports